import React from 'react';
import { connect } from 'react-redux';
import { Input } from 'module-tsl-ui-elements';

import { SET_SEARCH_VALUE } from '../state/constants';

const Search = ({ value, changeSearchValue, clearSearchValue }) => (
  <div className="nav-search">
    <Input
      id="search"
      placeholder="Search"
      value={value}
      clearable
      onChange={changeSearchValue}
      onCleared={clearSearchValue}
    />
  </div>
);

const mapStateToProps = (state) => ({
  value: state.searchValue,
})

const mapDispatchToProps = (dispatch) => ({
  changeSearchValue: ({ target: { value }}) => dispatch({ type: SET_SEARCH_VALUE, payload: value }),
  clearSearchValue: () => dispatch({ type: SET_SEARCH_VALUE, payload: '' }),
})

export default connect(mapStateToProps, mapDispatchToProps)(Search);
